<template>
  <el-config-provider :locale="zhCn">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import { onMounted } from "vue"
import zhCn from 'element-plus/es/locale/lang/zh-cn'
console.log("process.env", process.env)
if (process.env.VUE_APP_PLATFORM === "electron") {
  localStorage.removeItem("token");
  localStorage.removeItem("token_time");
  localStorage.removeItem("loginInfo");
}
onMounted(() => {
  const heartbeat = sessionStorage.getItem("heartbeat");
  if (!heartbeat) {
    localStorage.removeItem("token");
    localStorage.removeItem("token_time");
    localStorage.removeItem("loginInfo");
  }
  // 执行清理或保存操作
  // localStorage.removeItem("token");
  // localStorage.removeItem("token_time");
  // localStorage.removeItem("loginInfo");
})
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border - box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans - serif;
  background: #f0f0f0;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.cellName {
  color: #b6b7b8;
}

.el-table__footer-wrapper tbody td.el-table__cell,
.el-table__header-wrapper tbody td.el-table__cell {
  font-weight: bold;
  color: #000;
}
</style>
